import React, { Component } from "react";
import EditableTable from "../../../../components/EditableTable";
import { CloseOutlined, PlusSquareOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip, Divider, Button } from 'antd';
import { getIbisPackageList, getPartLibraryListBySearch } from "../../../../services/Sierra/library";
import { PART_IBIS_LIBRARY } from "../../../../constants/libraryConstants";
import ModelSelectPanel from "./modelSelectPanel"
import { valueUnitSplit } from "../../../../services/helper/valueUnitSplit";
import { numberCheck } from "../../../../services/helper/dataProcess";
import { PartBufferData, checkFileAndModelName } from "../../../../services/Sierra/library/partBufferLibraryHelper";
import "./index.css";

const columns = [
  {
    title: "Part Number",
    dataIndex: "partNumber",
    key: "partNumber",
    width: 200,
    textWrap: 'word-break',
    ellipsis: true,
    sorter: (a, b) => a && a.partNumber && b && b.partNumber && a.partNumber.localeCompare(b.partNumber),
  },
  {
    title: "IBIS File",
    dataIndex: "file",
    key: "file",
    // width: "35%",
    width: 200,
    ellipsis: true,
  },
  {
    title: "IBIS Component",
    dataIndex: "component",
    key: "component",
    width: 100,
    textWrap: 'word-break',
    ellipsis: true,
  },
  {
    title: "Pin",
    dataIndex: "pin",
    key: "pin",
    width: 100,
    textWrap: 'word-break',
    ellipsis: true,
  },
  {
    title: "Signal Type",
    dataIndex: "signalType",
    key: "signalType",
    width: 100,
    textWrap: 'word-break',
    ellipsis: true,
  },
  {
    title: "Speed",
    dataIndex: "speed",
    key: "speed",
    width: 120,
    textWrap: 'word-break',
    ellipsis: true,
  },
  {
    title: "Tx Model",
    dataIndex: "txModel",
    key: "txModel",
    width: 200
  },
  {
    title: "Rx Model",
    dataIndex: "rxModel",
    key: "rxModel",
    width: 200
  }
]
class IBISLibrary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      componentVisible: false,
      ibisComponentList: [],
      libraryExist: false,
      pinVisible: false,
    }

    columns.forEach((column) => {
      switch (column.dataIndex) {
        case "partNumber":
          column.onCell = (record) => {
            return {
              edit: true,
              dataIndex: "partNumber",
              record,
              handleSave: this.editPartNumber,
              rowSpan: record.rowSpan,
            }
          }
          column.render = (text, record) => {
            return (
              <div className="sierra-part-library-table-part-text">
                <span title={text}>{text}</span>
                <Tooltip
                  classNames={{ root: "icon-tooltip" }}
                  title="Delete the partNumber."
                >
                  <CloseOutlined
                    className="sierra-part-library-delete-icon"
                    onClick={(e) => this.deletePart(e, record)} />
                </Tooltip>
              </div >
            );
          }
          break;
        case "file":
          column.render = (text) => {
            const { checkFiles } = this.props;
            const fileNotExist = (text && checkFiles && checkFiles.length && checkFiles.includes(text));
            return <div className="sierra-part-library-table-text">
              <span title={text} style={{ paddingRight: fileNotExist ? 16 : 0 }}>{text}</span>
              {fileNotExist ? <Tooltip
                classNames={{ root: "icon-tooltip" }}
                title="The file is not uploaded to the library.">
                <QuestionCircleOutlined className="sierra-part-library-help-icon" />
              </Tooltip> : null}
            </div>
          }

          column.onCell = (record) => {
            if (!record.partNumber) {
              return {
                edit: false,
                rowSpan: record.rowSpan,
              }
            }
            return {
              edit: true,
              dataIndex: "file",
              record,
              handleSave: (record, prevRecord) => this.editTableData(record, prevRecord, column.dataIndex),
              tdClick: (e) => this.openTableCell(e, record, "file"),
              rowSpan: record.rowSpan,
            }
          }
          break;
        case "component":
          column.render = (text) => {
            return <div className="sierra-part-library-table-text">
              <span title={text}>{text}</span>
            </div>
          }

          column.onCell = (record) => {
            if (!record.partNumber || !record.file) {
              return {
                edit: false,
                rowSpan: record.rowSpan
              }
            }
            const { componentVisible } = this.state;
            const { checkFiles } = this.props;
            const fileNotExist = !record.partNumber || (record.file && checkFiles && checkFiles.length && checkFiles.includes(record.file));
            const defaultRes = {
              edit: true,
              record,
              dataIndex: "component",
              rowSpan: record.rowSpan,
              tdClick: (e) => this.openTableCell(e, record, fileNotExist ? "notExist" : "component")
            }
            if (checkFiles && checkFiles.length && checkFiles.includes(record.file)) {
              return {
                ...defaultRes,
                handleSave: (record, prevRecord) => this.editTableData(record, prevRecord, column.dataIndex),
              }
            } else if (componentVisible && componentVisible === record.partNumber) {
              const { ibisComponentList } = this.state;
              return {
                ...defaultRes,
                edit: "select",
                options: [...(ibisComponentList || [])],
                handleSave: (record, prevRecord) => this.editTableData(record, prevRecord, column.dataIndex),
                getPopupContainer: document.getElementById('root')
              }
            }

            return defaultRes;
          }
          break;
        case "pin":
          column.render = (text, record) => {
            return (
              <div className="sierra-part-library-table-part-text sierra-part-library-table-pin-text">
                <span title={text}>{text}</span>
                <Tooltip
                  classNames={{ root: "icon-tooltip" }}
                  title="Add Pin"
                >
                  <PlusSquareOutlined
                    className="sierra-part-library-delete-icon sierra-part-library-add-icon"
                    onClick={(e) => this.addPin(e, record)} />
                </Tooltip>

                <Tooltip
                  classNames={{ root: "icon-tooltip" }}
                  title="Delete the pin."
                >
                  <CloseOutlined
                    className="sierra-part-library-delete-icon"
                    onClick={(e) => this.deletePin(e, record)} />
                </Tooltip>
              </div >
            );
          }

          column.onCell = (record) => {
            if (!record.partNumber) {
              return {
                edit: false
              }
            }
            return {
              edit: true,
              record,
              dataIndex: "pin",
              handleSave: (record, prevRecord) => this.editTableData(record, prevRecord, column.dataIndex),
            }
          }
          break;
        case "signalType":
          column.onCell = (record) => {
            if (!record.partNumber) {
              return {
                edit: false
              }
            }
            return {
              edit: "select",
              record,
              dataIndex: "signalType",
              options: ["CLK", "DATA"],
              handleSave: (record, prevRecord) => this.editTableData(record, prevRecord, column.dataIndex),
              getPopupContainer: document.getElementById('root')
            }
          }
          break;
        case "speed":
          column.render = (text = "") => {
            return <div className="sierra-part-library-table-text">
              <span title={text}>{`${text}${text ? "Hz" : ""}`}</span>
            </div>
          }
          column.onCell = (record) => {
            if (!record.partNumber) {
              return {
                edit: false
              }
            }

            const { value, unit } = valueUnitSplit(record.speed || "");
            return {
              record: { ...record, value, unit },
              edit: 'input-with-select',
              dataIndex: "value",
              allowEmpty: true,
              defaultUnit: "K",
              handleSave: (record, prevRecord) => this.editSpeed(record, prevRecord, column.dataIndex),
              unitList: [
                { key: 'K', title: 'KHz' },
                { key: 'M', title: 'MHz' },
                { key: 'G', title: 'GHz' },
              ],
              notChangeUnit: true,
              size: "small"
            }
          }
          break;
        case "txModel":
        case "rxModel":
          column.render = (_, record) => {
            const { checkFiles } = this.props;
            const model = record[column.dataIndex] || {};
            const fileTooltip = checkFileAndModelName(checkFiles, model.fileName, model.modelName);
            const text = [model.fileName, model.modelName].filter(it => it).join(", ");
            return <div className="sierra-part-library-table-text">
              <span title={text} style={{ paddingRight: fileTooltip ? 16 : 0 }}>{text}</span>
              {fileTooltip ? <Tooltip
                classNames={{ root: "icon-tooltip" }}
                title={fileTooltip}>
                <QuestionCircleOutlined className="sierra-part-library-help-icon" />
              </Tooltip> : null}
            </div>
          }

          column.onCell = (record) => {
            if (!record.partNumber) {
              return {
                edit: false
              }
            }
            const { libraryTreeInfo } = this.props;
            return {
              edit: true,
              record,
              model: record[column.dataIndex] || {},
              title: column.title,
              dataIndex: column.dataIndex,
              customInput: ModelSelectPanel,
              handleSave: (record, prevRecord) => this.editTableData(record, prevRecord, column.dataIndex),
              libraryTreeInfo
            }
          }
          break;
        default:
          break;
      }
    })
  }

  addNewPart = (e) => {
    e && e.stopPropagation()
    const { data } = this.props
    let _data = [...data];
    if (!!_data.find(item => !item.id)) {
      return;
    }
    const itemData = {
      id: "",
      partNumber: "",
      file: "",
      component: "",
      pin: "",
      signalType: "",
      speed: "",
      txModel: {},
      rxModel: {}
    }
    _data.unshift(itemData)
    this.setState({
      componentVisible: false,
      ibisComponentList: []
    })
    this.props.saveData({ data: _data });
  }

  deletePart = (e, record) => {
    e && e.stopPropagation()
    const { data } = this.props
    const _data = data.filter(item => item.partNumber !== record.partNumber);
    const delParts = data.filter(item => item.partNumber === record.partNumber);
    this.setState({
      componentVisible: false,
      ibisComponentList: []
    })
    this.props.saveData({ data: _data, delParts });
  }

  editPartNumber = async (record, prevRecord) => {
    const { data } = this.props;
    if (prevRecord.partNumber === record.partNumber) {
      return;
    }
    const modelList = await getPartLibraryListBySearch({ partNumbers: [record.partNumber], type: PART_IBIS_LIBRARY });
    const findModel = (modelList || []).find(item => item.partNumber === record.partNumber);
    const defaultEditInfo = { partNumber: record.partNumber };
    if (findModel) {
      defaultEditInfo.file = findModel.file;
      defaultEditInfo.component = findModel.component;
    }

    const editedParts = [];
    const samePartIndex = data.findIndex(item => item.partNumber === record.partNumber);
    const _data = data.map(item => {
      if (item.partNumber !== prevRecord.partNumber) {
        return item;
      }
      editedParts.push({ ...item, ...defaultEditInfo });
      return { ...item, ...defaultEditInfo };
    })

    this.setState({
      componentVisible: false,
      ibisComponentList: []
    })
    this.props.saveData({ data: _data, editedParts, index: record.index, isMerge: samePartIndex !== -1 });
  }

  openTableCell = async (e, record, type) => {
    e && e.stopPropagation()
    let visible = this.state[`${type}Visible`];
    if (visible === record.partNumber) {
      return;
    }
    if (["notExist", "file"].includes(type)) {
      this.setState({
        componentVisible: false,
        ibisComponentList: []
      })
      return;
    }
    let ibisComponentList = [];
    const modelList = await getPartLibraryListBySearch({ partNumbers: [record.partNumber], type: PART_IBIS_LIBRARY });
    const findModel = (modelList || []).find(item => item.partNumber === record.partNumber);

    const libraryExist = findModel && findModel.libraryId;
    const res = findModel && findModel.libraryId ? await getIbisPackageList(findModel.libraryId) : null;
    if (res && res.length > 0) {
      ibisComponentList = res.map(item => item.component)
    }
    this.setState({
      [`${type}Visible`]: record.partNumber,
      ibisComponentList,
      libraryExist
    })
  }

  editSpeed = (record, prevRecord, dataIndex) => {
    const { value, unit } = record;
    let speed = "";
    const numberError = numberCheck(value, false, true);
    if (numberError) {
      this.props.updateMessage(`The speed ${numberError}`);
      return;
    }

    if (!value || !unit) {
      speed = "";
    } else {
      speed = `${Number(record.value)}${record.unit}`;
    }

    this.editTableData({ ...record, speed }, prevRecord, dataIndex);
  }

  editTableData = (record, prevRecord, dataIndex) => {
    const { data } = this.props;
    let _data = [...data];
    const editDatas = _data.filter(item => item.partNumber === record.partNumber);
    this.setState({
      componentVisible: false,
      ibisComponentList: []
    })
    if (editDatas.length > 1 && ['file', 'component'].includes(dataIndex)) {
      this.editMultiTableData(record, prevRecord, dataIndex);
    } else {
      this.editSingleTableData(record, prevRecord, dataIndex);
    }
  }

  editMultiTableData = (record, prevRecord, dataIndex) => {
    const { data } = this.props;
    const editedParts = [];
    const _data = data.map(item => {
      if (item.partNumber !== prevRecord.partNumber) {
        return item;
      }

      editedParts.push({ ...item, [dataIndex]: record[dataIndex] })
      return { ...item, [dataIndex]: record[dataIndex] }
    });
    switch (dataIndex) {
      case "file":
        this.props.saveData({ data: _data, editedParts, prevFile: prevRecord.file, checked: true });
        break;
      case "component":
        this.props.saveData({ data: _data, editedParts });
        break;
      default:
        break;
    }
  }

  editSingleTableData = (record, prevRecord, dataIndex) => {
    const { data } = this.props;
    let _data = JSON.parse(JSON.stringify(data));
    const index = record.index;
    _data[index][dataIndex] = record[dataIndex];
    switch (dataIndex) {
      case "file":
        this.props.saveData({ data: _data, editedParts: [{ ..._data[index] }], prevFile: prevRecord.file, checked: true });
        break;
      case "component":
      case "pin":
        const isExistSamePin = data.find(item => item.partNumber === record.partNumber && item.pin === record.pin && item.id !== record.id);
        if (isExistSamePin) {
          this.props.updateMessage(`This pin already exists.`);
          break;
        };
        this.props.saveData({ data: _data, editedParts: [{ ..._data[index] }] })
        break;
      case "signalType":
      case 'speed':
      case "txModel":
      case "rxModel":
        this.props.saveData({ data: _data, editedParts: [{ ..._data[index] }] });
        break;
      default:
        break;
    }
  }

  addPin = (e, record) => {
    e && e.stopPropagation();
    const { index } = record;
    const { data } = this.props
    const dataInfo = new PartBufferData({ ...record, id: "", pin: "", signalType: "", speed: "", txModel: {}, rxModel: {} });
    data.splice(index + 1, 0, dataInfo);
    this.props.saveData({ data, editedParts: [dataInfo], index: index + 1 });
  }

  deletePin = (e, record) => {
    e && e.stopPropagation()
    const { data } = this.props
    const _data = data.filter(item => item.partNumber !== record.partNumber || item.pin !== record.pin);
    const delParts = data.filter(item => item.partNumber === record.partNumber && item.pin === record.pin);
    this.setState({
      componentVisible: false,
      ibisComponentList: []
    })
    this.props.saveData({ data: _data, delParts })
  }

  render() {
    const { data, /*pageSize, page, totalElements*/ } = this.props;
    return <div>
      <div className="part-library-menu-list">
        {this.props.uploadExcelRender()}
        <Divider type="vertical" />
        {this.props.exportExcelRender()}
        <Divider type="vertical" />
        <Button type="link" className="part-library-add-button" onClick={(e) => this.addNewPart(e)}>Add Part Number</Button>
        <Divider type="vertical" />
        {this.props.checkFileButton()}
      </div>
      <div className="part-buffer-table-content">
        <EditableTable
          columns={columns}
          dataSource={data.map((item, index) => ({ ...item, index }))}
          rowKey={(record) => record.id ? record.id : `${record.partNumber}_${record.component}_${record.pin || ""}_${record.index}`}
          size="small"
          // pagination={{
          //   position: "bottom",
          //   pageSize,
          //   current: page,
          //   hideOnSinglePage: true,
          //   onChange: this.props.onPageChange,
          //   total: totalElements
          // }}
          sticky={{ offsetHeader: 0 }}
          scroll={{ x: 'max-content' }}
        />
      </div>
    </div>
  }
}

export default IBISLibrary;